import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppNavItem } from '../models';
@Component({
  selector: 'sj-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss']
})
export class SidebarMenuComponent implements OnInit {

  @Input() environment: any;
  @Input() sidebarActive: any;
  @Input() appMain: any;
  @Input() navItems: AppNavItem[] = [];
  @Input() logo: any;
  @Input() popup: boolean = true;
  @Input() authorities: string[] = [];
  @Output() sidebarClick = new EventEmitter<any>();
  @Output() sidebarMoseOver = new EventEmitter<any>();
  @Output() sidebarMouseLeave = new EventEmitter<any>();
  @Output() toggleMenu = new EventEmitter<any>();

  private parseNavchildren: AppNavItem[] = [];
  private itemsLocal: AppNavItem[] = [];
  items: AppNavItem[] = [];
  responsiveOptions: any = [];
  products: any = [];
  message = '';
  isLoader = false;

  constructor(
  ) {
  }

  ngOnInit(): void {
    this.navMenu();
  }

  navMenu() {
    if (this.navItems != null) {
      this.items = [];
      const itemFilter = (items: AppNavItem[]): AppNavItem[] => {
        return items.filter(item => {
          return item.permissions == undefined || item.permissions?.length == 0 || this.hasAnyPermission(item.permissions);
        }).map(item => {
          if (item.children) {
            item.items = itemFilter(item.children)
          }
          return item;
        }).filter(item => {
          return (item.items == undefined || item.items.length == 0) ? item.routerLink == undefined ? false : item.routerLink.length != 0 : true;
        });
      }
      this.rawNavchildren.then(items => {
        this.items = itemFilter(items);
      }).finally(() => {
        this.isLoader = true;

      })
    }
  }

  get rawNavchildren(): Promise<AppNavItem[]> {
    this.parseNavchildren = [];
    let tempSub: Subscription;
    return new Promise<AppNavItem[]>((resolve) => {
      this.parseNavchildren = this.navItems.filter(item => {
        return item.status == undefined || item.status
      }).map(item => {
        return item;
      })
      resolve(this.parseNavchildren);
    }
    ).finally(() => { if (tempSub) tempSub.unsubscribe(); });

    // return new Promise<AppNavItem[]>(resolve => resolve(this.parseNavchildren));
  }

  hasAnyPermission(authorities: string[]): boolean {
    let validation = this.authorities?.filter(authoritie => {
      return authorities.includes(authoritie)
    });
    return validation == undefined ? false : authorities.length == 0 ? false : validation.length == authorities.length;
  }

  onSidebarClick(event: any) {
    this.sidebarClick.emit(event);
  }

  onSidebarMouseOver(event: any) {
    this.sidebarMoseOver.emit(event);
  }

  onSidebarMouseLeave(event: any) {
    this.sidebarMouseLeave.emit(event);
  }

  onToggleMenu(event: any) {
    this.toggleMenu.emit(event);
  }

  urlMenu(envFront: string, param?: string): void {
    window.open(envFront + '/' + param + '?return=menugateway&', '_self');
  }

}

